// extracted by mini-css-extract-plugin
export default {"mobileVert":"Communication_mobileVert__4UQvP"};